import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const getInitialServiceType = () => {
    if (typeof window !== "undefined") {
        const saved = sessionStorage.getItem("persist:root");
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                if (parsed.session) {
                    const sessionData = JSON.parse(parsed.session);
                    return sessionData.serviceType || "ST";
                }
            } catch (error) {
                console.error("Error parsing sessionStorage:", error);
            }
        }
    }
    return "ST"; // 기본값
};

const getInitialStockName = () => {
    if (typeof window !== "undefined") {
        const saved = sessionStorage.getItem("persist:root");
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                if (parsed.session) {
                    const sessionData = JSON.parse(parsed.session);
                    return sessionData.stockName || "";
                }
            } catch (error) {
                console.error("Error parsing sessionStorage:", error);
            }
        }
    }
    return ""; // 기본값
};

interface SessionState {
    serviceType: string;
    stockName: string;
}

const initialState: SessionState = {    
    serviceType: getInitialServiceType(),
    stockName: getInitialStockName(),
};

const sessionSlice = createSlice({
    name: "main",
    initialState,
    reducers: {
        setServiceType: (state, action: PayloadAction<string>) => {
            state.serviceType = action.payload;
        },
        setStockName: (state, action: PayloadAction<string>) => {
            state.stockName = action.payload;
        },
    },
});


export const { setServiceType, setStockName } = sessionSlice.actions;
export default sessionSlice.reducer;
